import { getStatsigParameter } from '@/tracking/statsig/general.functions';

export function isStatsigPreselectBaggageByDefault(): boolean {
    const value = getStatsigParameter(
        'checkout_baggage_default_selected',
        'selected',
        false
    ) as boolean;

    return value;
}
